import React, {Fragment} from 'react'
import Header from '../components/Header'
import Hero from '../components/Privacy/Hero'
import Content from '../components/Privacy/Content'
import Footer from '../components/Footer'

class Privacy extends React.Component{
    constructor(props){
        super(props)
    }

    render(){
        return(
            <Fragment>
                <Header logoColor="#46e2b9" classStatic="" dropDownColor="black" title="Albert" />
                <Hero/>
                <Content />
                <Footer/>
            </Fragment>
        )
    }
}

export default Privacy;